export const LOCAL = {
	affiliate_id : 'FGDSHE146C67B44BABBF4E65GDDGDG',
	currency     : "BYN"
};


// WEBPACK FOOTER //
// ./src/app/constants/local.js